import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const NYX_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  1: setDirectAnswerPreset(
    undefined,
    // "EYE CATEGORY - UPON ARRIVAL, BEFORE zoning or stocking, please count how many NYX EYE items are out of stock in the NYX Cosmetics EYE category",
    /BEFORE zoning.*NYX EYE/i,
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].nyx.eye_oos_before()
  ),
  2: setDirectAnswerPreset(
    undefined,
    // "FACE Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many NYX FACE items are out of stock in the NYX Cosmetics FACE category",
    /BEFORE zoning.*NYX FACE/i,
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].nyx.face_oos_before()
  ),
  3: setDirectAnswerPreset(
    undefined,
    // "LIP Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many NYX LIP items are out of stock in the NYX Cosmetics LIP category",
    /BEFORE zoning.*NYX LIP/i,
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].nyx.lip_oos_before()
  ),
  4: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of NYX Cosmetics products you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].nyx.total_stocked()
  ),
  5: setDependentAnswerPreset(
    undefined,
    // "NYX COSMETICS EYE: After Zoning/Stocking/Merchandising, what is the Total # of EYE items are Out Of Stock during this visit",
    /nyx.*eye.*after zoning|after zoning.*nyx.*eye/i,
    "text",
    [1],
    beautyUtils.getAfterOOSCount
  ),
  6: setDependentAnswerPreset(
    undefined,
    // "NYX Cosmetics FACE: After Zoning/Stocking/Merchandising, what is the Total # of FACE items are Out Of Stock during this visit",
    /nyx.*face.*after zoning|after zoning.*nyx.*face/i,
    "text",
    [2],
    beautyUtils.getAfterOOSCount
  ),
  7: setDependentAnswerPreset(
    undefined,
    // "NYX Cosmetics LIP: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    /nyx.*lip.*after zoning|after zoning.*nyx.*lip/i,
    "text",
    [3],
    beautyUtils.getAfterOOSCount
  ),
  8: setDependentAnswerPreset(
    undefined,
    "NYX COSMETICS EYE: How many Out Of Stock EYE items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [5],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  9: setDependentAnswerPreset(
    undefined,
    "NYX Cosmetics FACE: How many Out Of Stock FACE items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [6],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  10: setDependentAnswerPreset(
    undefined,
    "NYX Cosmetics LIP: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [7],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  11: setDependentAnswerPreset(
    "NYX Cosmetics",
    "Select why 0 Items needed a count correction",
    "text",
    [8, 9, 10],
    beautyUtils.getWhyZeroItemsNeededCountCorrection
  ),
  11.5: setDependentAnswerPreset(
    "NYX Cosmetics",
    "Confirm 0 out of stock items need a count correction",
    "radio",
    [8, 9, 10],
    (dependencyAnswers) => {
      if (beautyUtils.getWhyZeroItemsNeededCountCorrection(dependencyAnswers) === null) return null;
      return "No out of stock items needzed a count correction";
    }
  ),
  12: setDirectAnswerPreset(
    "NYX Cosmetics",
    "Are there shelf labels missing on the NYX Cosmetic POG",
    "radio",
    () => "No shelf labels are missing from the NYX POG"
  ),
  13: setDependentAnswerPreset(
    "NYX Cosmetics Count Corrections",
    "Did a Team Lead assist you during your service to correct any NYX Cosmetics incorrect counts for out of stock items in the Inventory Audit",
    "radio",
    [8, 9, 10],
    beautyUtils.getDidATeamMemberAssistYouWithUpdatingOnHands
  ),
  14: setDependentAnswerPreset(
    undefined,
    "NYX COSMETICS EYE: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [8],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  15: setDependentAnswerPreset(
    undefined,
    "NYX Cosmetics FACE: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [9],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  16: setDependentAnswerPreset(
    undefined,
    "NYX Cosmetics LIP: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [10],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  100: setDirectAnswerPreset(
    undefined,
    "TIME CHECK - Do you have time to start working on L'Oreal Cosmetics",
    "radio",
    () => "Yes I have remaining time to start working on L'Oreal Cosmetics"
  ),
  101: setDirectAnswerPreset(
    undefined,
    "Did you clean the fixtures and any product needing cleaning on the L'Oreal POG & NYX Cosmetics POG",
    "radio",
    () => "Yes- all sections on the L'Oreal & NYX POG are clean"
  ),
  102: setDirectAnswerPreset(
    undefined,
    "Did you have time to finish all Eye and Face and Lip section Service objectives today",
    "radio",
    () => "Yes"
  ),
};
